import React, { FC, useEffect, useRef, useState } from 'react';
import {
	disputeReverse,
	exportCSVDisputes, fetchDisputes,
	fetchDisputesCardBrands,
	fetchDisputesManagementSystems, fetchKountStatusCodes
} from '../../../store/disputes/actions/disputes';
import { useDisputesContext } from '../../../store/disputes/disputes-context';
import { RefundForm } from './RefundForm';
import { DisputesFilterSection, IDisputesFilters } from './DisputesFilterSection';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { TablesNames } from '../../../store/tables/tables-context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IModalWindow, ModalWindow } from '../../modal/ModalWindow';
import { DisputesDetailPanel } from './DisputesDetailPanel';
import { useTranslation } from 'react-i18next';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { Table } from '../../table/Table';
import { Dropdown } from 'rsuite';
import { IDisputesPaginationData } from '../../../store/disputes/disputes-interfaces';
import { useLocation } from 'react-router';
import { makeSearchParams, parseSearchParams } from '../../../utils/utilities';
import { useNavigate } from 'react-router-dom';
import { ExportCSVButton } from '../../form/ExportCSVButton';

export const DisputesList: FC = () => {
	const { disputesContextState, dispatch } = useDisputesContext();
	const { isDisputesExportLoading } = disputesContextState;
	const { merchantState: { chosenMerchant, isPartnerNamesListLoading }} = useMerchants();

	const isMounted = useRef(false);
	const { t } = useTranslation();
	const { pathname, search } = useLocation();
	const navigate = useNavigate();

	const [isDisputesDataLoading, setIsDisputesDataLoading] = useState<boolean>(true);
	const [disputesData, setDisputesData] = useState<IDisputesPaginationData>(null);

	const [from, setFrom] = useState<Date | string>(null);
	const [to, setTo] = useState<Date | string>(null);
	const [createdFrom, setCreatedFrom] = useState<Date | string>(null);
	const [createdTo, setCreatedTo] = useState<Date | string>(null);
	const [requestFrom, setRequestFrom] = useState<Date | string>(null);
	const [requestTo, setRequestTo] = useState<Date | string>(null);
	const [timezone, setTimezone] = useState<string>('UTC');
	const [query, setQuery] = useState<string>('');
	const [providerName, setProviderName] = useState<string[]>([]);
	const [cardType, setCardType] = useState<string[]>([]);
	const [stage, setStage] = useState<string[]>([]);
	const [isWebhook, setIsWebhook] = useState<string>('');
	const [isFileImported, setIsFileImported] = useState<string>('');
	const [isManualInserted, setIsManualInserted] = useState<string>('');
	const [pageSize, setPageSize] = useState<string>('10');
	const [pageNumber, setPageNumber] = useState<string>('1');

	const [appliedFiltersState, setAppliedFiltersState] = useState<IDisputesFilters>(null);


	const [reverseModalState, setReverseModalState] = useState({
		isOpen: false,
		disputeId: null,
	});
	const [refundModalState, setRefundModalState] = useState({
		isOpen: false,
		data: null,
	});
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const filtersFromUrl: IDisputesFilters = parseSearchParams(search) || {};

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));
	const closeReverseModal = (): void => setReverseModalState({ isOpen: false, disputeId: '' });

	const fetchDisputeData = async (searchParams: IDisputesFilters): Promise<void> => {
		setIsDisputesDataLoading(true);

		const data = await fetchDisputes(searchParams);

		setDisputesData(data);

		setIsDisputesDataLoading(false);
	};

	useEffect(() => {
		void fetchDisputesManagementSystems(dispatch);
		void fetchDisputesCardBrands(dispatch);
		void fetchKountStatusCodes(dispatch);
	}, []);

	useEffect(() => {
		if (!isMounted.current) return;

		const params = { ...filtersFromUrl };

		params.mid = chosenMerchant;
		params.pageNumber = '1';

		if (!params.timezone) {
			// default value
			params.timezone = 'UTC';
		}

		if (!params?.pageSize) {
			params.pageSize = '10';
		}

		navigate(`${pathname}?${makeSearchParams(params)}`);
	}, [chosenMerchant]);

	useEffect(() => {
		if (!isMounted.current) {
			isMounted.current = true;
		}
	}, []);

	const rowActions = (rowData): JSX.Element => {
		return (
			<>
				<Dropdown
					noCaret
					icon={<FontAwesomeIcon icon={faEllipsis} className="mx-1"/>}
					placement="bottomEnd"
					className="text-muted dispute-dropdown"
				>
					<Dropdown.Item
						onClick={(): void => setReverseModalState({ isOpen: true, disputeId: rowData?.original?.id })}
						className="fw-bolder fs-7 main-font-family"
						disabled={rowData?.original?.stage === 'REVERSED'}
					>
						Reverse
					</Dropdown.Item>
				</Dropdown>
				{/*{*/}
				{/*	!rowData?.original?.isRefunded && (*/}
				{/*		<ButtonComponent*/}
				{/*			buttonName='Refund'*/}
				{/*			buttonType={BUTTON_TYPE.WHITE}*/}
				{/*			onButtonClick={(): void => setRefundModalState({ isOpen: true, data: rowData?.original })}*/}
				{/*		/>*/}

				{/*	)*/}
				{/*}*/}
			</>
		);
	};

	const handleSuccess = (): void => {
		setRefundModalState({ isOpen: false, data: null });
		setModalState({
			isOpen: true,
			modalTitle: 'Refund information',
			content: (
				<div className="fs-6">
					Refund information was successfully saved!
				</div>
			),
			confirmButtonText: t('PARTNERS.SUCCESS_BTN_NAME'),
			minHeight: 100,
			onConfirm: async () => {
				closeModal();
				await fetchDisputeData(filtersFromUrl);
			},
			onClose: closeModal
		});
	};

	const handleError = (): void => {
		setRefundModalState({ isOpen: false, data: null });
		setModalState({
			isOpen: true,
			modalTitle: 'Refund information',
			content: (
				<div className="fs-6 text-danger">
					Failed adding Refund information.
				</div>
			),
			confirmButtonText: t('PARTNERS.FAIL_BTN_NAME'),
			minHeight: 100,
			onConfirm: () => {
				setModalState(prev => ({ ...prev, isOpen: false }));
				setRefundModalState(prev => ({ ...prev, isOpen: false }));

			},
			onClose: closeModal
		});
	};

	const handleReverseSuccess = (): void => {
		closeReverseModal();
		setModalState({
			isOpen: true,
			modalTitle: 'Reverse dispute',
			content: (
				<div className="fs-6">
					Dispute was successfully reversed!
				</div>
			),
			confirmButtonText: t('PARTNERS.SUCCESS_BTN_NAME'),
			minHeight: 100,
			onConfirm: async () => {
				closeModal();
				await fetchDisputeData(filtersFromUrl);
			},
			onClose: closeModal
		});
	};

	const handleReverseError = (): void => {
		closeReverseModal();
		setModalState({
      isOpen: true,
      modalTitle: 'Reverse dispute',
      content: (
        <div className="fs-6 text-danger">
          Failed reverse dispute.
        </div>
      ),
      confirmButtonText: t('PARTNERS.FAIL_BTN_NAME'),
      minHeight: 100,
      onConfirm: closeModal,
      onClose: closeModal
    });
	};

  const listener = async (searchParams: IDisputesFilters): Promise<void> => {
	  if (!chosenMerchant && !searchParams?.mid) {
		  const merchantId = localStorage.getItem('chosenMerchant');
		  if (merchantId) {
			  return;
		  }
	  }
	  let localSearch: IDisputesFilters;

	  if (Object.keys(searchParams).length) {
		  localSearch = searchParams;

			localSearch.isMatch = 'true';
			setFrom(searchParams?.from ?? null);
			setTo(searchParams?.to ?? null);
			setCreatedFrom(searchParams?.createdFrom ?? null);
			setCreatedTo(searchParams?.createdTo ?? null);
			setRequestFrom(searchParams?.requestFrom ?? null);
			setRequestTo(searchParams?.requestTo ?? null);
			setTimezone(searchParams?.timezone ?? '');
			setQuery(searchParams?.query ?? '');
			setIsWebhook(searchParams?.isWebhook ?? '');
			setIsFileImported(searchParams?.isFileImported ?? '');
			setIsManualInserted(searchParams?.isManualInserted ?? '');
			setPageSize(searchParams?.pageSize ?? '10');
			setPageNumber(searchParams?.pageNumber ?? '1');

			if (searchParams?.cardType && typeof searchParams?.cardType === 'string') {
				setCardType([searchParams?.cardType]);
			} else {
				setCardType(searchParams?.cardType ?? []);
			}

			if (searchParams?.providerName && typeof searchParams?.providerName === 'string') {
				setProviderName([searchParams?.providerName]);
			} else {
				setProviderName(searchParams?.providerName ?? []);
			}

			if (searchParams?.stage && typeof searchParams?.stage === 'string') {
				setStage([searchParams?.stage]);
			} else {
				setStage(searchParams?.stage ?? []);
			}

			const initialFiltersData = {
				from: searchParams?.from ?? null,
				to: searchParams?.to ?? null,
				createdFrom: searchParams?.createdFrom ?? null,
				createdTo: searchParams?.createdTo ?? null,
				requestFrom: searchParams?.requestFrom ?? null,
				requestTo: searchParams?.requestTo ?? null,
				timezone: searchParams?.timezone ?? '',
				query: searchParams?.query ?? '',
				providerName: searchParams?.providerName && typeof searchParams?.providerName === 'string'
					? [searchParams?.providerName]
					: searchParams?.providerName ?? [],
				cardType: searchParams?.cardType && typeof searchParams?.cardType === 'string'
					? [searchParams?.cardType]
					: searchParams?.cardType ?? [],
				stage: searchParams?.stage && typeof searchParams?.stage === 'string'
					? [searchParams?.stage]
					: searchParams?.stage ?? [],
				isWebhook: searchParams?.isWebhook ?? '',
				isFileImported: searchParams?.isFileImported ?? '',
				isManualInserted: searchParams?.isManualInserted ?? '',
				pageSize: searchParams?.pageSize ?? '10',
				pageNumber: searchParams?.pageNumber ?? '1',
			};


			setAppliedFiltersState(initialFiltersData);

	  } else {
		  localSearch = {
				mid: chosenMerchant,
				pageNumber: '1',
				pageSize: '10',
			  timezone: 'UTC',
			  isMatch: 'true',
			};

			setAppliedFiltersState({
				from: null,
				to: null,
				createdFrom: null,
				createdTo: null,
				requestFrom: null,
				requestTo: null,
				timezone: 'UTC',
				query: '',
				providerName: [],
				cardType: [],
				stage: [],
				isWebhook: '',
				isFileImported: '',
				isManualInserted: '',
				pageSize: '10',
				pageNumber: '1',
			});
	  }

	  await fetchDisputeData(localSearch);

	};

	return (
		<div className="dipute-page" id="dipute-page" data-cy="dipute-page">

			<DisputesFilterSection
				from={from}
				to={to}
				createdFrom={createdFrom}
				createdTo={createdTo}
				requestFrom={requestFrom}
				requestTo={requestTo}
				timezone={timezone}
				query={query}
				providerName={providerName}
				cardType={cardType}
				stage={stage}
				isWebhook={isWebhook}
				isFileImported={isFileImported}
				isManualInserted={isManualInserted}
				setFrom={setFrom}
				setTo={setTo}
				setCreatedFrom={setCreatedFrom}
				setCreatedTo={setCreatedTo}
				setRequestFrom={setRequestFrom}
				setRequestTo={setRequestTo}
				setTimezone={setTimezone}
				setQuery={setQuery}
				setProviderName={setProviderName}
				setCardType={setCardType}
				setStage={setStage}
				setIsWebhook={setIsWebhook}
				setIsFileImported={setIsFileImported}
				setIsManualInserted={setIsManualInserted}
				pageSize={pageSize}
				pageNumber={pageNumber}
				isDisputesDataLoading={isDisputesDataLoading}
				appliedFiltersState={appliedFiltersState}
				setAppliedFiltersState={setAppliedFiltersState}
			/>

			<Table
				name={TablesNames.disputesTableData}
				data={disputesData?.rows || []}
				totalItemCount={disputesData?.totalItemCount}
				isLoading={isDisputesDataLoading || isPartnerNamesListLoading}
				positionActionsColumn='last'
				enableRowActions={true}
				rowActions={rowActions}
				actionColumnsSize={60}
				renderDetailPanel={DisputesDetailPanel}
				queryParamsListener={listener}
				toolbarCustomAction={
					<ExportCSVButton
						orderTotalItemCount={disputesData?.totalItemCount}
						isExportCSVLoading={isDisputesExportLoading}
						exportCSV={async (): Promise<void> => await exportCSVDisputes(dispatch, filtersFromUrl)}
					/>
				}
			/>

			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>

			<ModalWindow
				isOpen={refundModalState.isOpen}
				modalTitle='Refund information'
				onClose={(): void => setRefundModalState({ isOpen: false, data: null })}
				contentClassName="d-block"
				backdrop="static"
				content={
					<RefundForm
						closeModal={(): void => setRefundModalState({ isOpen: false, data: null })}
						data={refundModalState.data}
						onSuccess={handleSuccess}
						onError={handleError}
					/>
				}
			/>

			<ModalWindow
				isOpen={reverseModalState.isOpen}
				modalTitle='Reverse dispute'
				onClose={closeReverseModal}
				backdrop="static"
				modalText="Are you sure you want to reverse dispute? Press 'Confirm' to continue."
				confirmButtonText="Confirm"
				onConfirm={(): Promise<void> => disputeReverse(reverseModalState?.disputeId, handleReverseSuccess, handleReverseError)}
				onCancel={closeReverseModal}
			/>
		</div>
	);
};
